<template>
    <el-watermark :font="font" :content="uname">
        <el-container :style="'height: '+innerHeight+'px; width: '+ screenWidth +'px;'" class="affix-container">
            <el-splitter layout="vertical">
                <el-splitter-panel :size="hide" :resizable="false">
                    <el-drawer v-model="drawer" direction="ltr" size='45%'>
                        <el-menu mode="vertical" :default-active="defaulturi?`${uri}?id=${defaulturi}`:uri"
                            :router="true" :ellipsis="false">
                            <div v-for="item in route" :key="item.path">
                                <el-menu-item :index="'/'+item.path" v-if="!item.tabsName.length"
                                    :key="`${item.path}-if`">
                                    {{item.authNme}}
                                </el-menu-item>
                                <el-sub-menu v-else :index="'/'+item.path" :key="`${item.path}-else`">
                                    <template #title>
                                        <span>{{item.authNme}}</span>
                                    </template>
                                    <el-menu-item :index="'/'+item.path+'?id='+sub"
                                        v-for="(sub, subIndex) in item.tabsName" :key="`${item.path}-${subIndex}`">
                                        {{sub}}
                                    </el-menu-item>
                                </el-sub-menu>
                            </div>
                        </el-menu>
                    </el-drawer>
                    <el-header v-show="hide">
                        <div style="margin-right:auto;" class="hidden-sm-and-up">
                            <el-button @click="drawer = true" icon="Expand" size="small">菜单</el-button>
                        </div>
                        <CatSelect v-model="postvalue" :options="postlist" v-if="postlist.length > 1" />
                        <el-menu :popper-offset="15" mode="horizontal" :default-active="uri" @select="menuClick"
                            :ellipsis="false" active-text-color="#fff" background-color="transparent"
                            text-color="#888ba0" class="hidden-xs-only">
                            <el-menu-item :index="'/'+item.path" v-for="item in route" :key="item.id">{{item.authNme}}
                            </el-menu-item>
                        </el-menu>
                        <div style="margin-left:auto">
                            <el-popover trigger="hover" content="你说的,我都愿意听(*^▽^*)">
                                <template #reference>
                                    <el-link style="margin-right:20px" icon="Message" type="info"
                                        :href="domain+'/v/#/WhisperMailbox?fr='+fingerprint"
                                        target="_blank">心语信箱</el-link>
                                </template>
                            </el-popover>
                            <el-popover trigger="hover" content="查看密钥">
                                <template #reference>
                                    <el-button size="small" icon="Key" circle plain @click="Generatekey" />
                                </template>
                            </el-popover>
                            <el-popover trigger="hover" content="批量上传数据">
                                <template #reference>
                                    <el-button size="small" icon="UploadFilled" circle plain @click="Upload"
                                        :type="uri == '/Upload' ? 'primary': 'info'" v-show="akey=='管理员'" />
                                </template>
                            </el-popover>
                            <el-popover trigger="hover" :content="'退出'+uname+'账号'">
                                <template #reference>
                                    <el-button size="small" icon="SwitchButton" type="primary" circle
                                        @click="logouts"></el-button>
                                </template>
                            </el-popover>
                        </div>
                    </el-header>
                </el-splitter-panel>
                <el-splitter-panel>
                    <main class="app-main"> <router-view /></main>
                </el-splitter-panel>
            </el-splitter>
        </el-container>
        <el-dialog v-model="centerDialogVisible" :title="uname+'密钥详情'" width="500" center>
            <el-descriptions :column="1" size="small" border>
                <el-descriptions-item>
                    <template #label>
                        <el-button icon="Refresh" size="small" @click="Generatekey" link>刷新临时密钥</el-button>
                    </template>
                    <el-button icon="DocumentCopy" link @click="copyText(key)">{{key}}</el-button>
                </el-descriptions-item>
                <el-descriptions-item>
                    <template #label>
                        <el-button size="small" @click="ViewDetails" icon="Search" link
                            :disabled='universalKey!="********"'>获取通用密钥</el-button>
                        <el-tooltip effect="light" content="通用密钥请妥善保管。" placement="top-start">
                            <el-icon style="font-size: 15px;">
                                <InfoFilled />
                            </el-icon>
                        </el-tooltip>
                    </template>
                    <el-button icon="DocumentCopy" link @click="copyText(universalKey)">{{universalKey}}</el-button>
                </el-descriptions-item>
                <el-descriptions-item>
                    <template #label>
                        <el-button size="small" @click="GetMcpKey" icon="Key" link
                            :disabled="mcpKeyLoading">获取MCP服务密钥</el-button>
                        <el-tooltip effect="light" content="MCP密钥绑定当前账号，可查范围与网页一致；密钥仅显示一次，丢失可重新获取（旧密钥自动停用）。" placement="top-start">
                            <el-icon style="font-size: 15px;">
                                <InfoFilled />
                            </el-icon>
                        </el-tooltip>
                    </template>
                    <el-button icon="DocumentCopy" link @click="copyText(mcpKey)" v-if="mcpKey">{{mcpKey}}</el-button>
                    <span v-else style="color:#999;font-size:12px">点击左侧按钮获取（仅显示一次）</span>
                </el-descriptions-item>
            </el-descriptions>
        </el-dialog>
    </el-watermark>
</template>

<script>
    import {
        ElMessage
    } from 'element-plus'
    import axios from "@/utils/request";
    import {
        quitPage
    } from '@/utils/dingtalk'
    import CatSelect from '@/components/CatSelect.vue'
    import {
        mapState
    } from 'vuex'
    import store from '@/store'
    export default {
        name: 'app',
        components: {
            CatSelect,
        },
        computed: {
            // Vue计算属性
            ...mapState(['uri', 'tab', 'tabs', 'route', 'uname', 'akey', 'postlist', 'postvalue', 'domain', 'hide',
                'defaulturi'
            ])
        },
        created() {
            this.fingerprint = window.localStorage.getItem('fingerprint')
        },
        mounted() {
            //获取屏幕尺寸
            // 高度: document.body.clientHeight
            this.innerHeight = document.documentElement.clientHeight
            store.dispatch('SETIH', document.documentElement.clientHeight)
            window.addEventListener('resize', () => {
                this.innerHeight = document.documentElement.clientHeight
                store.dispatch('SETIH', document.documentElement.clientHeight)
            }, false)
            // 宽度: document.body.clientWidth
            this.screenWidth = document.documentElement.clientWidth
            store.dispatch('SETSW', document.documentElement.clientWidth)
            window.addEventListener('resize', () => {
                this.screenWidth = document.documentElement.clientWidth
                store.dispatch('SETSW', document.documentElement.clientWidth)
            }, false)
        },
        data() { // 可直接挂载到data数据上
            return {
                centerDialogVisible: false,
                key: '',
                universalKey: '********',
                mcpKey: '',
                mcpKeyLoading: false,
                innerHeight: '',
                screenWidth: '',
                drawer: false,
                font: {
                    fontSize: 14,
                    color: 'rgba(0, 0, 0, 0.08)'
                },
                fingerprint: '',
                muri: null
            }
        },
        methods: {
            logouts() { //退出登录
                axios({
                    method: "get",
                    url: 'logout'
                })
                window.sessionStorage.clear()
                window.localStorage.clear()
                window.location.reload()
                quitPage()
            },
            Upload() {
                this.$router.push(`/Upload`)
            },
            menuClick(v) {
                let tab = this.tabs[v] ?? []
                window.location.href = this.domain + '/#' + (tab.length ? v + "?id=" + tab[0] : v);
            },
            Generatekey() {
                if (!this.centerDialogVisible) {
                    this.centerDialogVisible = true
                }
                this.key = '获取中...'
                axios({
                    method: "post",
                    url: 'getdataother',
                    data: {
                        tabname: '获取一个密钥',
                        search: {},
                        csearch: null,
                    },
                }).then(res => {
                    this.key = res.key
                })
            },
            ViewDetails() {
                axios({
                    method: "post",
                    url: 'getdataother',
                    data: {
                        tabname: '获取一个信息',
                        search: {},
                        csearch: null,
                    },
                }).then(res => {
                    this.universalKey = res
                })
            },
            async copyText(v) {
                try {
                    await navigator.clipboard.writeText(v);
                    ElMessage.success("复制成功");
                } catch (error) {
                    ElMessage.warning("复制失败");

                }
            },
            GetMcpKey() {
                if (this.mcpKeyLoading) return
                this.mcpKeyLoading = true
                axios({
                    method: "post",
                    url: 'getdataother',
                    data: {
                        tabname: '获取MCP密钥',
                        search: {},
                        csearch: null,
                    },
                }).then(res => {
                    if (res && res.key) {
                        this.mcpKey = res.key
                        ElMessage.success('MCP 密钥获取成功，仅此一次显示，请立即复制保存')
                    } else {
                        ElMessage.warning('MCP 密钥获取失败')
                    }
                }).finally(() => {
                    this.mcpKeyLoading = false
                })
            }
        }
    }
</script>

<style scoped>
    #app {
        font-family: Avenir, Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #2c3e50;
    }

    nav {
        padding: 30px;
    }

    nav a {
        font-weight: bold;
        color: #2c3e50;
    }

    nav a.router-link-exact-active {
        color: #42b983;
    }


    .el-header,
    .el-footer {
        background-color: #171e49;
        color: #333;
        text-align: center;
        line-height: 60px;
    }

    .el-aside {
        position: relative;
        background-color: rgb(0, 21, 41);
        color: #fff;
        text-align: center;
        line-height: 200px;
    }

    .app-main {
        margin: 0.375rem;
        text-align: center;
    }

    .el-menu {
        border-right: 0;
        text-align: left;
    }

    .el-header {
        display: flex;
        justify-content: left;
        text-align: center;
    }

    .header_img {
        padding: 5px;
        width: 178px;
    }

    /* 主容器样式 */
    .custom-select {
        width: 150px;
        line-height: 60px;
        background-color: #171e49;
    }
</style>